import type { ParentIssueType } from '@risksmart-app/domain/src/types/consts';

import { t } from '../../i18n-t';
import type { FormConfig } from '../types';
import { issueTypeTaxonomy } from './variants';

export const getIssueFormConfig = (parentIssueType: ParentIssueType) => {
  const taxonomyLookup = issueTypeTaxonomy[parentIssueType];
  const taxonomy = taxonomyLookup.taxonomy;

  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`${taxonomy}.fields.Title`),
      columnHeader: t(`${taxonomy}.columns.title`),
      allowAsConditionSource: true,
    },
    Details: {
      fieldId: 'Details',
      formLabel: t(`${taxonomy}.fields.Details`),
      columnHeader: t(`${taxonomy}.columns.details`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    ImpactsCustomer: {
      fieldId: 'ImpactsCustomer',
      formLabel: t(`${taxonomy}.fields.ImpactsCustomer`),
      columnHeader: t(`${taxonomy}.columns.impacts_customer`),
      displayType: { displayType: 'commonLookup', i18nKey: 'yesOrNo' },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    IsExternalIssue: {
      fieldId: 'IsExternalIssue',
      formLabel: t(`${taxonomy}.fields.IsExternalIssue`),
      columnHeader: t(`${taxonomy}.columns.internal_or_external_issue`),
      displayType: {
        displayType: 'commonLookup',
        i18nKey: 'issues.isExternalIssue',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    DateOccurred: {
      fieldId: 'DateOccurred',
      formLabel: t(`${taxonomy}.fields.DateOccurred`),
      columnHeader: t(`${taxonomy}.columns.date_occurred`),
      allowAsConditionSource: true,
      displayType: { displayType: 'date' },
    },
    DateIdentified: {
      fieldId: 'DateIdentified',
      formLabel: t(`${taxonomy}.fields.DateIdentified`),
      columnHeader: t(`${taxonomy}.columns.date_identified`),
      allowAsConditionSource: true,
      displayType: { displayType: 'date' },
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t(`${taxonomy}.fields.Owner`),
      columnHeader: t(`columns.owners`),
      allowTargetConditions: true,
      allowAsConditionSource: true,
      displayType: {
        displayType: 'users',
        multiple: true,
      },
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t(`${taxonomy}.fields.Contributor`),
      columnHeader: t(`columns.contributors`),
      allowTargetConditions: true,
      allowAsConditionSource: true,
      displayType: {
        displayType: 'users',
        multiple: true,
      },
    },
    Viewers: {
      fieldId: 'Viewers',
      formLabel: t(`fields.Viewer`),
      columnHeader: t(`columns.viewers`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    files: {
      fieldId: 'files',
      formLabel: t(`${taxonomy}.fields.newFiles`),
      allowTargetConditions: true,
    },
    tags: {
      fieldId: 'tags',
      formLabel: t(`${taxonomy}.fields.Tags`),
      columnHeader: t(`columns.tags`),
      allowTargetConditions: true,
      allowAsConditionSource: true,
      displayType: {
        displayType: 'tags',
      },
    },
    departments: {
      fieldId: 'departments',
      formLabel: t(`${taxonomy}.fields.Departments`),
      columnHeader: t(`columns.departments`),
      allowTargetConditions: true,
      allowAsConditionSource: true,
      displayType: {
        displayType: 'departments',
      },
    },
  } as const satisfies FormConfig;
};
